import React, { Component } from "react";
import NavTab from '../../components/common/global_layout/navTab2'
import CustomCard from '../../components/common/customCard'
import { Container ,Row} from "reactstrap";
import {connect } from 'react-redux';


class Divertissement extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
  

 
  


    render() { 
        return ( 
            <>
            <NavTab />
            <Container>
            <div className='custom-card cards-Vol'>
              <Row >
                <CustomCard
                  height={250}
                  size={6}
                  imgPath={"/imgs/Divertissement/attraction2.png"}
                  linkPath={"/"}
                  title={"Attraction"}
                  subtitle={"70000 DZD"}
                />
                <CustomCard
                  height={250}
                  size={6}
                  imgPath={"/imgs/Divertissement/Sahara2.png"}
                  linkPath={"/"}
                  title={"Quad au désert"}
                  subtitle={"70000 DZD"}
                />
              </Row>
              <Row className="second-cards-Vol">
                <CustomCard
                  height={250}
                  size={4}
                  imgPath={"/imgs/Divertissement/Sky2.png"}
                  linkPath={"/"}
                  title={"SkyDiving"}
                  subtitle={"70000 DZD"}

                />              
                <CustomCard
                  height={250}
                  size={4}
                  imgPath={"/imgs/Divertissement/plonge2.png"}
                  linkPath={"/"}
                  title={"Plongée"}
                  subtitle={"70000 DZD"}
                />              
                <CustomCard
                  height={250}
                  size={4}
                  imgPath={"/imgs/Divertissement/marche2.png"}
                  linkPath={"/"}
                  title={"Randonnés"}
                  subtitle={"70000 DZD"}
                />
              </Row>
            </div>
            </Container>
            </>
         );
    }
}
 

//connects component with redux store state
function mapStateToProps(state) {
  return {
    /*
    login: state.counterApp.login,
    signUp:state.counterApp.signUp,
    startDate: state.counterApp.startDate,
    endDate: state.counterApp.endDate
*/
  }
}
export default (Divertissement);